import React from 'react';
import { ClickableTicker } from '../TradingViewModal';

interface PremarketBannerProps {
  watchlist: string[];
}

const PremarketBanner: React.FC<PremarketBannerProps> = ({ watchlist }) => {
  if (watchlist.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-2 text-sm text-amber-600 dark:text-amber-400">
      <div className="flex items-center gap-2">
        <span>🎯</span>
        <span className="font-medium">
          Premarket Focus — {watchlist.length} high-priority securities
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {watchlist.map((symbol) => (
          <ClickableTicker key={symbol} symbol={symbol}>
            {symbol}
          </ClickableTicker>
        ))}
      </div>
    </div>
  );
};

export default PremarketBanner;
